<template>
  <div id="page-product-details">
    <section-ancestors-form
      v-model="model"
      ref="form"
      :loading="loading"
      card-title="Create Ancestor"
      @formLoading="setLoading"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.sections.ancestors.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="disableCreate"
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationMixin from '@/components/mixins/NotificationMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import SectionAncestorsForm from './SectionAncestorsForm';

export default {
  name: 'SectionRiskCodeCreate',
  components: {
    SectionAncestorsForm
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {},
      loading: false,
      createLoading: false
    };
  },
  computed: {
    disableCreate() {
      return this.createLoading || this.loading;
    },
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    setLoading(loadingState) {
      this.createLoading = loadingState;
    },
    getParams() {
      const params = this.getModelCopy(true);

      const multiReferences = [
        {
          array: 'facility_section',
          key: ['Facility_FK']
        }
      ];

      const references = ['SectionParent_FK'];

      this.setReferences(references);
      this.setMultiReferences(multiReferences);

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const { data } = await this.$api.facilities.sections.createAncestor(
          params,
          this.$route.params.sectionId
        );
        this.notifySuccess('Ancestor created');
        await this.$router.push({ name: 'facilities.sections.ancestors.list' });
      } catch (e) {
        this.notifyError('Section failed to be created');
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
</style>
